import React from 'react';
import Button from '../components/ui/Button';

const Dining = () => {
  return (
    // Increased top padding from pt-24 to pt-36
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl mb-6">Restaurant & Bar</h1>
          <p className="text-lg text-brand-600 max-w-2xl mx-auto">
            Enjoy a relaxed dining experience during your stay.
          </p>
        </div>

        {/* Section 1: Culinary Delights */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="order-2 md:order-1">
            <h2 className="text-3xl mb-6">Culinary Delights</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-serif mb-2 text-brand-500">Cuisine</h3>
                <ul className="list-disc list-inside text-brand-700 space-y-1">
                  <li>African cuisine</li>
                  <li>Chinese cuisine</li>
                  <li>Mediterranean cuisine</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-serif mb-2 text-brand-500">Dietary Options</h3>
                <ul className="list-disc list-inside text-brand-700 space-y-1">
                  <li>Vegetarian options available on request</li>
                  <li>Halal options available on request</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <img 
              src="https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/64ec7aab015f08812dfb85b221335370.jpg" 
              alt="Restaurant Culinary Delights" 
              className="w-full h-[400px] object-cover rounded-lg shadow-lg" 
            />
          </div>
        </div>

        {/* Section 2: Breakfast */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div>
            <img 
              src="https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/5e9446cc49a9b029927b981eb2f77880.jpg" 
              alt="Breakfast" 
              className="w-full h-[400px] object-cover rounded-lg shadow-lg" 
            />
          </div>
          <div>
            <h2 className="text-3xl mb-6">Breakfast</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-serif mb-2 text-brand-500">Start Your Day Right</h3>
                <p className="text-brand-600 mb-2">May include:</p>
                <ul className="list-disc list-inside text-brand-700 space-y-1">
                  <li>À la carte breakfast</li>
                  <li>Vegetarian breakfast</li>
                  <li>Halal breakfast</li>
                </ul>
                <p className="text-sm italic text-brand-500 mt-4">
                  Note: Guests should select their travel dates to view available room and breakfast options.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 3: Bar */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
          <div className="order-2 md:order-1">
             <h2 className="text-3xl mb-6">Bar</h2>
             <div>
                <h3 className="text-xl font-serif mb-2 text-brand-500">Relax & Unwind</h3>
                <p className="text-brand-700 leading-relaxed">
                  Our on-site bar offers a perfect setting to relax with refreshing cocktails, fine wines, and beverages. Enjoy the tropical ambiance after a day of exploring Zanzibar.
                </p>
             </div>
          </div>
          <div className="order-1 md:order-2">
            <img 
              src="https://canv.wasacon.com/amani-resort-zanzibar/_assets/media/53fb244fe9c12dd6df0195b9a9c27456.jpg" 
              alt="Bar" 
              className="w-full h-[400px] object-cover rounded-lg shadow-lg" 
            />
          </div>
        </div>

        <div className="text-center mt-16">
          <Button to="/contact" variant="primary">Reserve a Table / Ask About Dietary Options</Button>
        </div>
      </div>
    </div>
  );
};

export default Dining;